var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49749 5C9.19961 5 8.93436 4.81149 8.83641 4.53018L7.66107 1.1546C7.44296 0.528171 6.55704 0.528171 6.33893 1.1546L5.16359 4.53017C5.06564 4.81149 4.80039 5 4.50251 5H1.0298C0.364399 5 0.0743595 5.84103 0.598315 6.25119L3.50445 8.52618C3.73598 8.70742 3.82956 9.01403 3.73871 9.29367L2.63364 12.6951C2.42411 13.3401 3.16225 13.8763 3.71083 13.4777L6.58855 11.3869C6.83389 11.2087 7.16611 11.2087 7.41145 11.3869L10.2892 13.4777C10.8378 13.8763 11.5759 13.3401 11.3664 12.6951L10.2613 9.29367C10.1704 9.01403 10.264 8.70742 10.4955 8.52618L13.4017 6.25119C13.9256 5.84103 13.6356 5 12.9702 5H9.49749Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ab2083605db41ad0807c29897a002a31.svg";
export { ForwardRef as ReactComponent };